@if (passedError()) {
  <app-login-error
    [error]="passedError()!"
    [cause]="passedCause() || undefined"
  ></app-login-error>
} @else if (isLoginStarted()) {
  <app-login-loading
    step="Anmelden mit Microsoft Account"
  ></app-login-loading>
} @else {
  @if(isProduction()) {
    <div class="min-h-screen flex items-center justify-center">
      <img ngSrc="assets/loading.gif" alt="loading app" height="600" width="800" />
    </div>
  } @else {
    <input
      placeholder="Token"
      class="w-full bg-white text-blue-600 p-2 rounded-lg mb-2"
      type="text"
      [(ngModel)]="devToken"
    />
    <app-login-button (click)="login()">
      <lucide-icon [img]="MockLoginIcon" size="24" />
      Sign in with Strapi Token
      <lucide-icon [img]="ArrowRight" size="24" />
    </app-login-button>
  }
}
